import { grey } from "@mui/material/colors";
import Txt from "../../../../../components/typography/Txt";
import Flx from "../../../../../components/layout/Flx";
import { Box, Divider } from "@mui/material";

const ExperienceSummaryCard = ({ label, recent, older }) => (
  <Box
    sx={{
      bgcolor: grey[50],
      borderRadius: "8px",
      p: 1.5,
      flexBasis: "255px",
      flexShrink: 0,
      flexGrow: 1,
      border: `1px solid ${grey[200]}`,
    }}
  >
    <Txt
      sx={{
        fontSize: "10px",
        fontWeight: 600,
        color: grey[500],
        textTransform: "uppercase",
        letterSpacing: "0.5px",
        mb: 1,
      }}
    >
      {label}
    </Txt>
    <Flx jb sx={{ mt: 2 }}>
      <Flx g={0.4} column>
        <Txt
          sx={{
            fontSize: "16px",
            fontWeight: 700,
            color: grey[800],
            lineHeight: 1,
          }}
        >
          {recent}
        </Txt>
        <Txt sx={{ fontSize: "10px", color: grey[400] }}>
          {"Less Than 3 years"}
        </Txt>
      </Flx>
      <Divider flexItem orientation="vertical" />
      <Flx g={0.4} column>
        <Txt
          sx={{
            fontSize: "16px",
            fontWeight: 700,
            color: grey[800],
            lineHeight: 1,
          }}
        >
          {older}
        </Txt>
        <Txt sx={{ fontSize: "10px", color: grey[400] }}>
          {"Greater than 3 years"}
        </Txt>
      </Flx>
    </Flx>
  </Box>
);

export default ExperienceSummaryCard;
